module.exports = __webpack_public_path__ + "static/media/7.12ede4eb.svg";